"use strict";
/**
 * 新版自选股接口
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var cookie = require("../cookie");
var userid = (cookie.get('ut') && cookie.get('ct') && cookie.get('uidal')) ? cookie.get('uidal').slice(0, 16) : undefined;
var apiurl = '//myfavor.eastmoney.com/v4/'; //正式环境
var appkey = 'e9166c7e9cdfad3aa3fd7d93b757e9b1';
var fingerprint = cookie.get('qgqp_b_id') || '';
if (userid) {
    apiurl += 'webouter/';
}
else {
    apiurl += 'anonymwebouter/';
}
exports["default"] = {
    /**
     * 获取自选股接口通用参数
     */
    getParams: function () {
        return __awaiter(this, void 0, void 0, function () {
            var fp;
            return __generator(this, function (_a) {
                if (userid) {
                    return [2 /*return*/, "appkey=" + appkey];
                }
                else {
                    fp = fingerprint;
                    return [2 /*return*/, "appkey=" + appkey + "&bid=" + fp];
                }
                return [2 /*return*/];
            });
        });
    },
    /**
     * 获取默认分组股票，检测是否加了自选
     * @param {*} code 股票代码 0.300059
     */
    defaultGroupList: function (code) {
        if (code === void 0) { code = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParams()];
                    case 1:
                        params = _a.sent();
                        code = code.replace('.', '$');
                        return [2 /*return*/, $.ajax({
                                url: apiurl + "gsaandcheck?" + params + "&cb=?",
                                type: 'GET',
                                dataType: 'jsonp',
                                data: {
                                    sc: code
                                }
                            })
                                .then(function (json) {
                                if (json.state == 0 && json.data && json.data.stkstarlist instanceof Array) {
                                    return {
                                        re: true,
                                        result: {
                                            check: json.data.check,
                                            list: json.data.stkstarlist.map(function (v) {
                                                return v.security.substring(0, v.security.lastIndexOf('$')).replace('$', '.');
                                            })
                                        }
                                    };
                                }
                                else {
                                    return {
                                        re: true,
                                        result: {
                                            check: false,
                                            list: []
                                        }
                                    };
                                }
                            })];
                }
            });
        });
    },
    /**
     * 加自选到默认分组
     * @param {*} code 股票代码
     */
    addDefaultStock: function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParams()];
                    case 1:
                        params = _a.sent();
                        code = code.toString().replace('.', '$');
                        return [2 /*return*/, $.ajax({
                                url: apiurl + "asz?" + params + "&cb=?",
                                type: 'GET',
                                dataType: 'jsonp',
                                data: {
                                    sc: code
                                }
                            }).then(function (back) {
                                if (back.state == 0) {
                                    return {
                                        re: true
                                    };
                                }
                                else {
                                    return {
                                        re: false,
                                        message: back.message
                                    };
                                }
                            })];
                }
            });
        });
    },
    /**
     * 删除默认分组的自选
     * @param {*} code 股票代码
     */
    deleteDefaultStock: function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParams()];
                    case 1:
                        params = _a.sent();
                        code = code.replace('.', '$');
                        return [2 /*return*/, $.ajax({
                                url: apiurl + "dsz?" + params + "&cb=?",
                                type: 'GET',
                                dataType: 'jsonp',
                                data: {
                                    sc: code
                                }
                            }).then(function (back) {
                                if (back.state == 0) {
                                    return {
                                        re: true
                                    };
                                }
                                else {
                                    return {
                                        re: false,
                                        message: back.message
                                    };
                                }
                            })];
                }
            });
        });
    }
};
